import { createAsyncAction } from 'typesafe-actions';
import { AxiosRequestConfig } from 'axios';
import { config } from '../../config';
import { IConfigResponseDetails } from '@store/reducers/config.reducer';

export const fetchConfig = createAsyncAction(
    [
        'config/FETCH_CONFIG_REQUEST',
        () => {
            return {
                method: 'get',
                baseURL: `${config.env('configUrl')}`,
                params: {
                    dynamic_node: 'features'
                }
            } as AxiosRequestConfig;
        }
    ],
    ['config/FETCH_CONFIG_SUCCESS', (response: IConfigResponseDetails) => response],
    'config/FETCH_CONFIG_FAILURE',
    'config/FETCH_CONFIG_CANCEL'
)();
